module.exports = __webpack_public_path__ + "img/halu.d55e6cce.png";